import Http from '../../../http';
import {
  CREATE_LOYALTY_PROGRAM,
  FETCH_LOYALTY_PROGRAM,
  UPDATE_LOYALTY_PROGRAM,
} from './constants';

const createAction = data => ({
  type: CREATE_LOYALTY_PROGRAM,
  payload: data,
});

export const createLoyalty = (ownerId, ownerType, data) => dispatch =>
  Http
    .post(`/${ownerType}/${ownerId}/reward`, data)
    .then(response => dispatch(createAction(response)));

const updateAction = data => ({
  type: UPDATE_LOYALTY_PROGRAM,
  payload: data,
});

export const updateLoyalty = (ownerId, ownerType, data) => dispatch =>
  Http
    .put(`/${ownerType}/${ownerId}/reward`, data)
    .then(response => dispatch(updateAction(response)));

const fetchAction = data => ({
  type: FETCH_LOYALTY_PROGRAM,
  payload: data,
});

export const fetchLoyalty = (ownerId, ownerType) => dispatch =>
  Http.get(`/${ownerType}/${ownerId}/reward`).then(data => dispatch(fetchAction(data)));
